import {
  takeEvery,
  put,
  call,
  delay,
  fork,
  takeLatest,
} from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* get_AccountPropertiesList(actions) {
  let uuid = actions.idUser ? actions.idUser : getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-account-properties?page=" + actions.page
        : apiUrl + "/opa-account-properties" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "LIST_ACCOUNT_PROPERTIES_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({ type: "LIST_ACCOUNT_PROPERTIES_RESPONSE_GET", value: error });
  }
}

function* get_AccountProperties(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-account-property/"
        : `${apiUrl}/opa-account-property/${actions.query}?include=googlePlace,images,claimedAccount`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "ACCOUNT_PROPERTIES_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "ACCOUNT_PROPERTIES_RESPONSE_GET", value: error });
  }
}

function* add_AccountProperties(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-property";

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* edit_AccountProperties(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-account-property/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }
    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_EDIT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* edit_AccountPropertiesList(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-account-property/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* delete_AccountProperties(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-account-property/" + actions.uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}


function* import_accountProperties(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = new FormData();
    formData.append("file", actions.file);

    const requestOptions = {
      headers: headers,
      body: formData,
    };

    let url =
      apiUrl + "/opa-account-properties-import?process=" + actions.process;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let importStep = "error";
    if (!actions.process) importStep = "upload";
    else importStep = "import";

    let responseStatus = response?.status || "failed";
    

    if (responseStatus === "success") responseStatus = "completed"; 
    if (response?.error) responseStatus = "failed";

    if (!response?.job_id && (response?.updated_count !== undefined || response?.created_count !== undefined)) {
        responseStatus = "completed";
    } else if (!response?.job_id && response?.total_records === 0) {
        if (!response?.updated_count) {
           responseStatus = "failed";
        }
    }

    const responseWithStatus = {
      ...response,
      responseStatus,
      importStep,
      status: responseStatus
    };

    yield put({
      type: "ACCOUNT_PROPERTIES_IMPORT",
      value: responseWithStatus,
    });

    if (response?.job_id) {
      window.localStorage.setItem("importPropertyPropertyJobId", response.job_id);
      window.localStorage.setItem("importPropertyPropertyStep", importStep);
      yield fork(poll_propertiesImportStatusSaga, {
        job_id: response.job_id,
        step: importStep,
        access: actions.access,
      });
    }

    return response;
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_IMPORT",
      value: { ...error, responseStatus: "failed", status: "failed" },
    });
    throw error;
  }
}


function* import_accountPropertiesImages(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = new FormData();
    formData.append("file", actions.file);
    if (actions.external_ids) {
      formData.append("external_ids", JSON.stringify(actions.external_ids));
    }

    const requestOptions = {
      headers: headers,
      body: formData,
    };

    let url = apiUrl + "/opa-upload-property-images?async=true&process=" + actions.process;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let importStep = "error";
    if (!actions.process) importStep = "upload";
    else importStep = "import";

    let responseStatus = response?.status || "failed";
    
    if (responseStatus === "success") responseStatus = "completed";
    if (response?.error) responseStatus = "failed";

    const responseWithStatus = {
      ...response,
      responseStatus,
      importStep,
      status: responseStatus
    };

    yield put({
      type: "ACCOUNT_PROPERTIES_IMPORT_IMAGES",
      value: responseWithStatus,
    });

    if (response?.job_id) {
      window.localStorage.setItem("importPropertyImagesJobId", response.job_id);
      window.localStorage.setItem("importPropertyImagesStep", importStep);
      yield fork(poll_importStatusSaga, {
        job_id: response.job_id,
        step: importStep,
        access: actions.access,
      });
    }

    return response;
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_IMPORT_IMAGES",
      value: { ...error, responseStatus: "failed", status: "failed" },
    });
    throw error;
  }
}

function* poll_importStatusSaga(actions) {
  const { job_id, step, access } = actions;
  const uuid = getSetCookie();

    try {
    const headers = {
      Authorization: `Bearer ${access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = { headers };

    let url = `${apiUrl}/opa-upload-property-images/status/${job_id}`;
    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const pollingInterval = step === "upload" ? 1000 : 5000;

    while (true) {
      yield delay(pollingInterval);

      const response = yield call(apiCall, "GET", url, requestOptions);

      let responseStatus = response?.status || "failed";
      let finalResponse = { ...response };

      if (responseStatus === "completed") {
        if (response.response && Object.keys(response.response).length > 0) {
          finalResponse = { 
            ...response, 
            ...response.response, 
            originalResponse: response.response 
          };
        }
      } else if (responseStatus === "success") {
        responseStatus = "completed";
      } else if (response?.error || responseStatus === undefined) {
        responseStatus = "failed";
      }

      const responseWithStatus = {
        ...finalResponse,
        responseStatus,
        importStep: step,
        status: responseStatus,
        isPolling: true
      };

      yield put({
        type: "ACCOUNT_PROPERTIES_IMPORT_IMAGES_PROGRESS",
        value: responseWithStatus,
      });

      if (responseStatus === "completed" || responseStatus === "failed") {
        window.localStorage.removeItem("importPropertyImagesJobId");
        window.localStorage.removeItem("importPropertyImagesStep");
        break;
      }
    }
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_IMPORT_IMAGES_PROGRESS",
      value: { ...error, responseStatus: "failed", status: "failed", importStep: step },
    });
    window.localStorage.removeItem("importPropertyImagesJobId");
    window.localStorage.removeItem("importPropertyImagesStep");
  }
}

function* resume_importImagesJob(actions) {
  const { job_id, step, access } = actions;
  yield fork(poll_importStatusSaga, { job_id, step, access });
}

function* poll_propertiesImportStatusSaga(actions) {
  const { job_id, step, access } = actions;
  const uuid = getSetCookie();

  try {
    const headers = {
      Authorization: `Bearer ${access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = { headers };

    let url = `${apiUrl}/opa-account-properties-import/status/${job_id}`;
    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const pollingInterval = step === "upload" ? 1000 : 5000;

    while (true) {
      yield delay(pollingInterval);

      const response = yield call(apiCall, "GET", url, requestOptions);

      let responseStatus = response?.status || "failed";
      let finalResponse = { ...response };

      if (responseStatus === "completed") {
        if (response.response && Object.keys(response.response).length > 0) {
          finalResponse = { 
            ...response, 
            ...response.response, 
            originalResponse: response.response 
          };
        }
      } else if (responseStatus === "success") {
        responseStatus = "completed";
      } else if (response?.error || responseStatus === undefined) {
        responseStatus = "failed";
      }

      const responseWithStatus = {
        ...finalResponse,
        responseStatus,
        importStep: step,
        status: responseStatus,
        isPolling: true
      };

      yield put({
        type: "ACCOUNT_PROPERTIES_IMPORT_PROGRESS",
        value: responseWithStatus,
      });

      if (responseStatus === "completed" || responseStatus === "failed") {
        window.localStorage.removeItem("importPropertyPropertyJobId");
        window.localStorage.removeItem("importPropertyPropertyStep");
        break;
      }
    }
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_IMPORT_PROGRESS",
      value: { ...error, responseStatus: "failed", status: "failed", importStep: step },
    });
    window.localStorage.removeItem("importPropertyPropertyJobId");
    window.localStorage.removeItem("importPropertyPropertyStep");
  }
}

function* resume_propertiesImportJob(actions) {
  const { job_id, step, access } = actions;
  yield fork(poll_propertiesImportStatusSaga, { job_id, step, access });
}

export function* getSagaAccountPropertiesList() {
  yield takeEvery("GET_ACCOUNT_PROPERTIES_LIST", get_AccountPropertiesList);
}

export function* getAccountProperties() {
  yield takeEvery("GET_ACCOUNT_PROPERTIES", get_AccountProperties);
}

export function* addAccountProperties() {
  yield takeEvery("ADD_ACCOUNT_PROPERTIES", add_AccountProperties);
}

export function* editAccountProperties() {
  yield takeEvery("EDIT_ACCOUNT_PROPERTIES", edit_AccountProperties);
}

export function* editAccountPropertiesList() {
  yield takeEvery("EDIT_ACCOUNT_PROPERTIES_LIST", edit_AccountPropertiesList);
}

export function* deleteAccountPropertiesSaga() {
  yield takeEvery("DELETE_ACCOUNT_PROPERTIES", delete_AccountProperties);
}

export function* importAccountProperties() {
  yield takeEvery("IMPORT_ACCOUNT_PROPERTIES", import_accountProperties);
}

export function* importAccountPropertiesImages() {
  yield takeEvery(
    "IMPORT_ACCOUNT_PROPERTIES_IMAGES",
    import_accountPropertiesImages,
  );
}

export function* resumeImportImagesJob() {
  yield takeLatest("RESUME_IMPORT_IMAGES_JOB", resume_importImagesJob);
}

export function* resumePropertiesImportJob() {
  yield takeLatest("RESUME_PROPERTIES_IMPORT_JOB", resume_propertiesImportJob);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
